function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/* eslint-disable */
// This icon has been generated. Do not edit it directly.
import React from 'react';
var IconExclamationMark = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IconExclamationMark, _React$PureComponent);
  function IconExclamationMark() {
    _classCallCheck(this, IconExclamationMark);
    return _possibleConstructorReturn(this, _getPrototypeOf(IconExclamationMark).apply(this, arguments));
  }
  _createClass(IconExclamationMark, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        color = _this$props.color,
        onClick = _this$props.onClick,
        size = _this$props.size,
        style = _this$props.style,
        width = _this$props.width,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["height", "color", "onClick", "size", "style", "width", "className"]);
      return React.createElement("svg", _extends({}, rest, {
        height: height || size,
        width: width || size,
        onClick: onClick,
        style: style,
        className: className,
        fill: color,
        viewBox: "27.1 344.9 151.9 151.9"
      }), React.createElement("path", {
        d: "M105.4 446.6h-4.7c-.5-8.2-2.1-18.1-4.9-29.6l-5.6-23.4c-3.4-14-5-24.1-5-30.2 0-12.3 5.9-18.4 17.8-18.4 5.2 0 9.5 1.7 12.9 5.1 3.4 3.4 5.1 7.7 5.1 13 0 5.6-1.8 15.8-5.4 30.5l-5.7 23.4c-2.1 8.2-3.6 18.1-4.5 29.6zm-2.2 15.3c5.5 0 9.8 1.9 12.9 5.6 3 3.7 4.6 7.7 4.6 11.9 0 5.6-1.8 9.9-5.5 12.9s-7.6 4.5-11.9 4.5c-5.6 0-9.9-1.8-12.9-5.5s-4.5-7.6-4.5-11.9c0-4.9 1.7-9.1 5-12.4 3.2-3.4 7.3-5.1 12.3-5.1z"
      }));
    }
  }]);
  return IconExclamationMark;
}(React.PureComponent);
_defineProperty(IconExclamationMark, "styleRoot", 'IconExclamationMark');
_defineProperty(IconExclamationMark, "defaultProps", {
  size: 32,
  color: '#333'
});
export { IconExclamationMark as default };